import dynamic from 'next/dynamic'

const Select = dynamic(() => import('@global/FormInput/Select'), { ssr: false })

/**
 * Reusable filter component for suburb profile sections
 * @param {Object} props
 * @param {string} props.bedrooms - Current bedrooms filter value
 * @param {Function} props.onBedroomsChange - Callback when bedrooms filter changes
 * @param {string} props.type - Current property type filter value
 * @param {Function} props.onTypeChange - Callback when property type filter changes
 */
const SuburbProfileFilters = ({
  bedrooms,
  availableBedrooms,
  onBedroomsChange,
  type,
  onTypeChange,
  isShowUnit = true,
  isShowHouse = true,
}) => {
  const allBedrooms = availableBedrooms[type || 'all']
    ?.filter((it) => it != '0' || it != 'Overall')
    .sort((a, b) => {
      if (a === 'Overall') return -1
      if (b === 'Overall') return 1
      return Number(a) - Number(b)
    })
    .map((it) => ({
      label:
        it === '1'
          ? '1 Bedroom'
          : `${it} Bedrooms`,
      value: it,
    })).filter((it) => it.value !== 'Overall')
  const bedroomsOptions = {
    all: allBedrooms,
    house: allBedrooms,
    unit: allBedrooms,
  }

  const typeOptions = [
    { label: 'All Property Types', value: 'all' },
    ...(isShowHouse ? [{ label: 'Houses', value: 'house' }] : []),
    ...(isShowUnit ? [{ label: 'Units', value: 'unit' }] : []),
  ]

  return (
    <div>
      <Select
        options={[
          { label: 'All Bedrooms', value: 'Overall' },
          ...bedroomsOptions[type || 'all'],
        ]}
        onChange={(option) => {
          onBedroomsChange(option.value)
        }}
        defaultValue={{
          label: 'Overall',
          value: 'Overall',
        }}
        placeholder='All Bedrooms'
        value={
          bedroomsOptions[type || 'all'].find(
            (opt) => opt.value === bedrooms
          ) || { label: 'All Bedrooms', value: 'Overall' }
        }
        isSearchable={false}
      />
      {onTypeChange && isShowHouse && isShowUnit && (
        <Select
          options={typeOptions}
          onChange={(option) => {
            onTypeChange(option.value)
            onBedroomsChange('Overall')
          }}
          defaultValue={{
            label: 'All Property Types',
            value: 'all',
          }}
          value={typeOptions.find((opt) => opt.value === type) || null}
          isSearchable={false}
        />
      )}
    </div>
  )
}

export default SuburbProfileFilters
